module.exports = __webpack_public_path__ + "static/media/share.aaa018a5.svg";